<template>
  <div class="avatar-root">
    <div class="avatar-picture" :style="{width: `${w}px`, height: `${h}px`}">
      <el-upload
          class="avatar-uploader"
          ref="avatar"
          :show-file-list="false"
          action="/api/index/up_img.json"
          :headers='fileUpHeaders'
          :data="fileUpData"
          :disabled="disabled"
          :before-upload="beforeAvatarUpload"
          :on-progress="handleAvatarProgress"
          :on-success="handleAvatarSuccess">
        <img v-if="avatar"
             :src="avatar"
             :style="{width: `${w}px`, height: `${h-2}px`}"
             @mouseenter="showOption = true"
             @mouseleave="showOption = false">
        <img v-else
             :src="imgSrc"
             :style="{width: `${w}px`, height: `${h-2}px`}">
      </el-upload>
      <div v-show="showProgress" class="avatar-progress">
        <el-progress type="circle" :percentage="percent"></el-progress>
      </div>
      <div v-show="showOption"
           class="avatar-option"
           @mouseenter="showOption = true"
           @mouseleave="showOption = false">
        <div class="icon-wrap">
          <i class="el-icon-zoom-in opt-icon" @click="previewImg"  v-if="showScaleBig"></i>
          <i class="el-icon-delete opt-icon" @click="deleteImg"></i>
        </div>
      </div>
    </div>
    <el-dialog :width="dw"
               :visible.sync="dialogVisible"
               class="preview-img">
      <img width="100%" :src="avatar" alt="">
    </el-dialog>
  </div>
</template>

<script>
  import {storageData} from "@/assets/js/storage";
  export default {
    name: "Photo",
    props: {
      showScaleBig:{
        required:false,
        type:Boolean,
        default:true,
      },
      imgUrl: {
        type: String,
        required: true
      },
      w: {
        type: Number,
        required: false,
        default: 130
      },
      h: {
        type: Number,
        required: false,
        default: 160
      },
      dw: {
        type: String,
        required: false,
        default: "450px"
      },
      imgType: {
        type: RegExp,
        required: false,
        default: () => {
          return /^image\/(jpeg|jpg|png|gif)$/i;
        }
      },
      typeTips: {
        type: String,
        required: false,
        default: '只能上传 jpg、png、jpeg、gif 格式的图片'
      },
      limitSize: {
        type: Number,
        required: false,
        default: 10
      },
      limitTips: {
        type: String,
        required: false,
        default: '上传图片大小不能超过 10MB'
      },
      disabled:{
        type:Boolean,
        default:false
      }
    },
    data() {
      return {
        avatar: '',
        tempAvatar: this.imgUrl,
        fileUpHeaders: {'X-Token': storageData.getToken(),"X-UserType":storageData.getUserType()},
        fileUpData: {image: ""},
        percent: 0,
        showProgress: false,
        showOption: false,
        dialogVisible: false,
      };
    },
    computed: {
      imgSrc: {
        get() {
          return this.imgUrl;
        },
        set(src) {
          this.$emit("update:imgUrl", src);
        },
      }
    },
    methods: {
      handleAvatarSuccess(res, file) {
        const {status, result: {image_url}} = res;
        if(Number(status) === 0) {
          // console.log(image_url);
          this.avatar = URL.createObjectURL(file.raw);
          this.imgSrc = image_url;
        }else{
          this.$message.error("上传出错，请重新上传");
          this.reset();
        }
        this.showProgress = false;
      },
      beforeAvatarUpload(file) {
        const isAccept = this.imgType.test(file.type);
        if (!isAccept) {
          this.$message.error(this.typeTips);
        }
        const isLtSize = file.size / 1024 / 1024 < this.limitSize;
        if (!isLtSize) {
          this.$message.error(this.limitTips);
        }
        if(isAccept && isLtSize) {
          this.$set(this.fileUpData, "image", file);
          this.percent = 0;
          this.showProgress = true;
        }
        return isAccept && isLtSize;
      },
      handleAvatarProgress(e) {
        this.percent = parseInt(e.percent);
      },
      reset() {
        this.$refs["avatar"].clearFiles();
        this.avatar = "";
        this.imgSrc = this.tempAvatar;
      },
      previewImg() {
        this.dialogVisible = true;
      },
      deleteImg() {
        // if(!this.avatar) return;
        this.reset();
        this.showOption = false;
      },
    }
  }
</script>

<style lang="stylus">
  .avatar-root {
    .preview-img {
      .el-dialog__header {
        padding: 0;
      }
      .el-dialog__body {
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
</style>
<style lang="stylus" scoped>
  @import "~@/assets/css/variable";
  .avatar-root {
    .avatar-picture {
      position: relative;
      /*width: 130px;
      height: 160px;*/
      border: 1px dashed $color_white;
      border-radius: 5px;
      overflow: hidden;
      user-select: none;
      .avatar-uploader {
        width: 100%;
        height: 100%;
        cursor: pointer;
        /*.avatar, .tipsImg {
          width: 130px;
          height: 158px;
        }*/
      }
      .avatar-progress {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 100;
        background-color: $color_white;
      }
      .avatar-option {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 100;
        background-color: $color_black;
        opacity: 0.8;
        .icon-wrap {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          .opt-icon {
            margin: 0 10px;
            font-size: $font_size_big;
            cursor: pointer;
          }
        }
      }
    }
  }
</style>
